import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section className="bg-background-50 py-24 md:py-32">
      <div className="max-w-[1000px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="text-primary-600 text-xs tracking-[0.32em] font-semibold mb-4">
            F. A. Q
          </div>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            자주 묻는 <span className="text-primary-600">질문</span>
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => (
            <div
              key={f.q}
              className={`border rounded-lg overflow-hidden transition ${
                open === i
                  ? "border-primary-400 bg-primary-50/40"
                  : "border-background-200 bg-background-50"
              }`}
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between text-left px-6 py-5 cursor-pointer"
              >
                <div className="flex items-center gap-4">
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full font-heading font-bold text-sm ${
                      open === i
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-100 text-foreground-700"
                    }`}
                  >
                    Q
                  </span>
                  <span className="font-semibold text-foreground-950">{f.q}</span>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-2xl transition ${
                    open === i ? "rotate-180 text-primary-600" : "text-foreground-500"
                  }`}
                ></i>
              </button>
              {open === i && (
                <div className="px-6 pb-6 pl-[76px] text-sm text-foreground-700 leading-relaxed">
                  {f.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}